import React, { useEffect, useRef, useState } from "react";

// APP COMPONENTS
import MerchantsService from "../../api/merchant";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const MerchantFilter = ({ selectedValue, onFilterChange }) => {
  const loadDataAttempts = useRef(0);
  const [merchants, setMerchants] = useState([]);

  useEffect(() => {
    loadData().then((r) => r);
  }, []);

  const loadData = async () => {
    try {
      const res = await MerchantsService.getMerchants();

      const merchants_treated = res.data.map((merchant) => {
        return {
          label: merchant.name,
          value: merchant.id,
        };
      });
      merchants_treated.unshift({
        label: "PDV / SALAO",
        value: "PDV",
      });
      merchants_treated.unshift({
        label: "Todos",
        value: "ALL",
      });

      setMerchants(merchants_treated);
    } catch (e) {
      console.log(e);
      loadDataAttempts.current += 1;

      if (loadDataAttempts.current < 2) {
        setTimeout(loadData, 100);
      }
    }
  };

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="merchant-values"
      options={merchants}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Loja"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

MerchantFilter.displayName = "Loja";

export default MerchantFilter;
